import { createFileRoute } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Trash2, Plus } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export const Route = createFileRoute("/admin/notices")({ component: NoticesAdmin });

function NoticesAdmin() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["admin_notices"],
    queryFn: async () => (await supabase.from("notices").select("*").order("created_at", { ascending: false })).data ?? [],
  });
  const [msg, setMsg] = useState("");

  async function add() {
    if (!msg.trim()) return;
    const { error } = await supabase.from("notices").insert({ message: msg.trim() });
    if (error) return toast.error(error.message);
    setMsg(""); toast.success("Notice added"); qc.invalidateQueries();
  }
  async function toggle(id: string, active: boolean) { await supabase.from("notices").update({ active }).eq("id", id); qc.invalidateQueries(); }
  async function del(id: string) { if (!confirm("Delete?")) return; await supabase.from("notices").delete().eq("id", id); qc.invalidateQueries(); }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-black">Notices</h1>
      <div className="rounded-2xl bg-card p-4 shadow-card">
        <Textarea placeholder="Enter notice message…" value={msg} onChange={(e) => setMsg(e.target.value)} />
        <Button onClick={add} className="mt-3 gradient-primary shadow-purple"><Plus className="mr-2 h-4 w-4" /> Add Notice</Button>
      </div>
      <div className="space-y-2">
        {(data ?? []).map((n: any) => (
          <div key={n.id} className="flex items-center gap-3 rounded-2xl bg-card p-4 shadow-card">
            <p className="flex-1 text-sm">{n.message}</p>
            <Switch checked={n.active} onCheckedChange={(v) => toggle(n.id, v)} />
            <button onClick={() => del(n.id)} className="text-destructive"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
